import React from "react";
import styles from "./HeadingCurved.css";

const HeadingCurved = ({ text }) => (
  <svg
    viewBox="0 0 400 120"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.heading}
  >
    <path
      id="curve"
      d="M0,46.35C43.82,18.24,114.45,0,194.12,0c82.87,0,156,19.74,199.26,49.78"
      transform="translate(0 75.01)"
      fill="none"
    />
    <text
      width="400"
      fontFamily="augusta"
      fontSize="80"
      fill="#000"
      stroke="#000"
      strokeWidth="10"
    >
      <textPath xlinkHref="#curve" startOffset="50%" textAnchor="middle">
        {text}
      </textPath>
    </text>
    <text width="400" fontFamily="augusta" fontSize="80" fill="#29abe2">
      <textPath xlinkHref="#curve" startOffset="50%" textAnchor="middle">
        {text}
      </textPath>
    </text>
  </svg>
);

export default HeadingCurved;



// WEBPACK FOOTER //
// ./src/components/HeadingCurved/HeadingCurved.js